module.exports = __webpack_public_path__ + "static/media/Test52.9186902f.bmp";